import {inject, injectable} from 'inversify';

import type {Expand, Expanded, MaybeExpanded} from '../../../../api/types';
import type {CourseMapperJrpc} from '../../Course/mappers/Course.mapper.jrpc';
import type {UserMapperJrpc} from '../../User/mappers/User.mapper.jrpc';

import {EnvProviderService} from '../../../system/env/EnvProvider.service';
import {BaseExpandJrpc} from '../../Base/mappers/Base.expand.jrpc';
import {CourseExpandJrpc} from '../../Course/mappers/Course.expand.jrpc';
import {UserExpandJrpc} from '../../User/mappers/User.expand.jrpc';

@injectable()
export class CoachHistoryExpandJrpc extends BaseExpandJrpc {
  constructor(
    @inject(EnvProviderService) env: EnvProviderService,
    @inject(UserExpandJrpc) private readonly userExpand: UserExpandJrpc,
    @inject(CourseExpandJrpc) private readonly courseExpand: CourseExpandJrpc,
  ) {
    super(env);
  }

  getByEnv(key?: BaseExpandJrpc.EnvKey): Expand {
    const base: Expand = {
      coach_history: [
        [
          'client_id',
          {name: 'Client not found'},
          this.userExpand.getByEnv(key),
        ],
        ['course_id', null, this.courseExpand.getByEnv(key)],
        ['new_coach_id', null, this.userExpand.getByEnv(key)],
        [
          'old_coach_id',
          {name: 'Coach not found'},
          this.userExpand.getByEnv(key),
        ],
      ],
    };
    const core: Expand = base;
    const b2b: Expand = base;

    return this.resolve({b2b, core, key});
  }
}

export namespace CoachHistoryExpandJrpc {
  export type ExpandedFields = {
    client: Expanded<UserMapperJrpc.ExpandedApiData, 'name'>;
    course: MaybeExpanded<CourseMapperJrpc.ExpandedApiData>;
    new_coach: MaybeExpanded<UserMapperJrpc.ExpandedApiData>;
    old_coach: Expanded<UserMapperJrpc.ExpandedApiData, 'name'>;
  };
}
